import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import AddressFormatter from "features/shared/components/formatters/AddressFormatter";
import { useTranslation } from "react-i18next";
import { ContractProcessDTO } from "../dtos/ContractProcessDTO";

type ContractProcessItem = NonNullable<ContractProcessDTO["result"]>[number];

interface Props { contractProcess: ContractProcessItem; }

const ContractProcessSuplyCard = ({ contractProcess }: Props) => {
  const t = useTranslation("contractProcess\\contractProcess").t;
  const tPlaceOfDeliveryType = useTranslation("contracts\\enums\\placeOfDeliveryType").t;

  return (
    <PageCard title={t("place.title")}>
      <div className="row no-gutters">
        <div className="col-12 col-md-6 col-lg-3 px-sm-3">
          <InfoItem title={t("place.placeOfDelivery")} value={contractProcess.contractEnergy?.placeOfDelivery || "-"} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 px-sm-3">
          <InfoItem title={t("place.placeOfDeliveryType")} value={tPlaceOfDeliveryType(contractProcess.contractEnergy?.placeOfDeliveryType!) || "-"} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 px-sm-3">
          <InfoItem title={t("place.address")} value={contractProcess.contractEnergy?.placeOfDeliveryAddress ? <AddressFormatter address={contractProcess.contractEnergy?.placeOfDeliveryAddress} /> : "-"} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 px-sm-3">
          <InfoItem title={t("place.distributionCompany")} value={contractProcess.contractEnergy?.distributionCompany || "-"} />
        </div>
      </div>
    </PageCard>
  );
};

export default ContractProcessSuplyCard;
